export const INVENTORY_STATUSES = {
	notListed: 1,
	listed: 2,
	delisted: 3,
};
